import { invertMap } from '@/sections/insights/queryBuilder/entities/common/invert';
import {
  getNotFromSimpleFilter,
  getOperatorFromQueryFilter,
  getOperatorFromSimpleFilter,
  getValueFromQueryFilter,
  getValueFromSimpleFilter,
} from '@/sections/insights/queryBuilder/entities/common/translators';
import type {
  SimpleFilter,
  SimpleFilterDefinition,
} from '@/sections/insights/queryBuilder/entities/types';
import type { QueryFilter } from '@/types';

const valueMap: Record<string, string> = {
  object: 'Object',
  user: 'User',
  computer: 'Computer',
  group: 'Group',
  gpo: 'GPO',
  ou: 'OU',
  container: 'Container',
  domain: 'Domain',
  localgroup: 'Local Group',
  localuser: 'Local User',
  aiaca: 'AIA CA',
  rootca: 'Root CA',
  enterpriseca: 'Enterprise CA',
  ntauthstore: 'NT Auth Store',
  certtemplate: 'Certificate Template',
  issuancepolicy: 'Issuance Policy',
};

const valueMapInverse = invertMap(valueMap);

const availableValues = [
  'Object',
  'User',
  'Computer',
  'Group',
  'GPO',
  'OU',
  'Container',
  'Domain',
  'Local Group',
  'Local User',
  'AIA CA',
  'Root CA',
  'Enterprise CA',
  'NTAuth Store',
  'Certificate Template',
  'Issuance Policy',
];

/**
 * Reusable field definition for AD Object class
 * Translates between API class values and AD label values
 */
export const ADObjectClass: SimpleFilterDefinition = {
  apiField: 'class',
  uiField: 'Class',
  inputType: 'dropdown',
  getAvailableValues: () => Promise.resolve(availableValues),
  operators: ['is', 'is not', 'is any of'],

  translateForUI: (queryFilter: QueryFilter): SimpleFilter => {
    return {
      field: 'Class',
      operator: getOperatorFromQueryFilter(queryFilter),
      value: getValueFromQueryFilter(valueMap, queryFilter),
    };
  },

  translateForAPI: (simpleFilter: SimpleFilter): QueryFilter => {
    return {
      field: 'class',
      operator: getOperatorFromSimpleFilter(simpleFilter),
      value: getValueFromSimpleFilter(valueMapInverse, simpleFilter),
      not: getNotFromSimpleFilter(simpleFilter),
    };
  },
};
